@if (vm$ | async; as vm) {
	<ng-container class="table-container">
		@if (!vm.error && vm.models.length === 0) {
			<div>De huidige selectie levert geen resultaten op.</div>
		} @else if (vm.models.length) {
			<cdk-virtual-scroll-viewport [appendOnly]="true" itemSize="200">
				@if (tableGroups?.length === 3) {
					<div class="inside">
						<div class="table-groups" *cdkVirtualFor="let level1 of vm.models; trackBy: trackByIx">
							@if (getTitle(level1[0][0], 1)) {
								<h3 [class.empty]="isNullTitle(level1[0][0], 1)" [attr.data-exportable]="exportable ? '' : undefined">
									{{ getTitle(level1[0][0], 1) }}
								</h3>
							}
							@for (level2 of level1; track trackByIx($index, level2)) {
								<div class="table-container horizontal">
									@for (model of level2; track trackByIx($index, model)) {
										<div>
											@if (getTitle(model, 3)) {
												<div
													class="label"
													[class.empty]="isNullTitle(model, 3)"
													[attr.data-exportable]="exportable ? '' : undefined"
												>
													{{ getTitle(model, 3) }}
												</div>
											}
											<app-table
												[model]="model"
												[sortActive]="vm.sortState.active"
												[sortDirection]="vm.sortState.direction"
												(rowClick)="rowClick($event)"
												[hoverHelp]="true"
												[exportable]="exportable"
												[voorgesteldeGroeperingen]="config.getAvailableGroups()"
												[allGroups]="config.allAvailableGroups()"
												[tableGroups]="tableGroups"
												[huidigeGroeperingen]="groeperingService.huidigeGroeperingen()"
												[subgroups]="subgroups"
												[currentGroupsDeletable]="config.flexibleGroupsRemovable"
											>
											</app-table>
										</div>
									}
								</div>
							}
						</div>
					</div>
				} @else {
					<div class="inside">
						@for (level1 of vm.models; track trackByIx($index, level1)) {
							<div>
								@for (level2 of level1; track trackByIx($index, level2)) {
									<div class="table-container">
										<div *cdkVirtualFor="let model of level2; trackBy: trackByIx">
											@if (getTitle(model, 1)) {
												<div
													class="label"
													[class.empty]="isNullTitle(model, 1)"
													[attr.data-exportable]="exportable ? '' : undefined"
												>
													{{ getTitle(model, 1) }}
												</div>
											}
											<app-table
												[model]="model"
												[sortActive]="vm.sortState.active"
												[sortDirection]="vm.sortState.direction"
												(rowClick)="rowClick($event)"
												[hoverHelp]="true"
												[exportable]="exportable"
												[incremental]="isIncrementalRender()"
												[voorgesteldeGroeperingen]="config.getAvailableGroups()"
												[allGroups]="config.allAvailableGroups()"
												[tableGroups]="tableGroups"
												[huidigeGroeperingen]="groeperingService.huidigeGroeperingen()"
												[subgroups]="subgroups"
												[currentGroupsDeletable]="config.flexibleGroupsRemovable"
											>
											</app-table>
										</div>
									</div>
								}
							</div>
						}
					</div>
				}
			</cdk-virtual-scroll-viewport>
		}
		@switch (vm.error?.error) {
			@case (ErrorEnum.BENCHMARK_NOT_ALLOWED) {
				<div>
					Helaas hebben wij op dit moment geen toestemming van jouw school om de noodzakelijke data voor de CumLaude benchmark te verwerken
					en te tonen. Neem voor meer informatie contact op met je beheerder.
				</div>
			}
			@case (ErrorEnum.LIMIT_EXCEEDED) {
				<div>
					De huidige selectie levert te veel ({{ vm.error!.parameters!["leaves"] }}) resultaten op. Voeg filters toe om deze te beperken tot
					minder dan {{ vm.error!.parameters!["limit"] }}.
				</div>
			}
			@case (ErrorEnum.UNKNOWN) {
				<div>Er is een onverwachte fout opgetreden.</div>
			}
			@case (ErrorEnum.UNEXPECTED) {
				<div>Er is een onverwachte fout opgetreden.</div>
			}
			@case (ErrorEnum.MISSING_MODULE) {
				<div>
					Deze school heeft module {{ vm.error!.parameters!["module"] }} niet afgenomen. Neem contact op met
					<a href="mailto:{{ envConfig.supportMail }}">CumLaude Support</a> om de mogelijkheden te bespreken.
				</div>
			}
			@case (ErrorEnum.MISSING_ROLE) {
				<div>
					Je kunt de gegevens niet opvragen als {{ vm.error!.parameters!["rol"] }} omdat je deze rol niet (meer) hebt. Neem contact op met
					de beheerder van CumLaude op je school.
				</div>
			}
			@case (ErrorEnum.NO_ACCESS) {
				<div>Je hebt geen toegang tot de gevraagde data. Neem contact op met de beheerder van CumLaude op je school.</div>
			}
		}
	</ng-container>
}
